export default {"src":"/_next/static/media/error-artwork.c1e94163.svg","height":320,"width":320,"blurWidth":0,"blurHeight":0};